import { useEffect, useState } from 'react'

export const usePermission = (name: PermissionName) => {
  const [permission, setPermission] = useState<PermissionState | null>(null)

  useEffect(() => {
    if (!(navigator.permissions && navigator.permissions.query)) {
      setPermission('prompt')
      return
    }

    /** The listener is removed on unmount, and never added if the query resolves after it (GH #2618) */
    let status: PermissionStatus | undefined
    let unmounted = false
    const handleChange = () => {
      if (status) {
        setPermission(status.state)
      }
    }
    void navigator.permissions.query({ name }).then(permissionStatus => {
      if (unmounted) {
        return
      }
      status = permissionStatus
      permissionStatus.addEventListener('change', handleChange)
      setPermission(permissionStatus.state)
    })
    return () => {
      unmounted = true
      status?.removeEventListener('change', handleChange)
    }
  }, [name])

  return { permission, disabled: permission !== 'granted' }
}
